'use client'

import Image from 'next/image'

import notFoundImage from '@/assets/images/not-found.png'

import { Link } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'
import styles from './styles.module.scss'

export default function NotFoundPage() {
  const t = useTranslations('NotFoundPage')
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('title')}</h2>
      <div className={styles.imgWrapper}>
        <Image src={notFoundImage} alt="not found page" />
      </div>
      <Link href="/" className={styles.link}>
        {t('link-text')}
      </Link>
    </div>
  )
}
